module.exports = __webpack_public_path__ + "img/first-day-5.1aa6320a.webp";